"use strict";module.exports=function(e,t){return{value:t,done:!!e}};